import {axiosGetHandler, axiosPostHandler } from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues();

/**
 * 创建角色
 * @param {*} args 
 * @returns 
 */
export function createRole (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/create'
	return axiosPostHandler(url, args, formdata)
}

/**
 * 删除角色
 * @param {*} args 
 * @returns 
 */
export function deleteRole (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/delete';
	return axiosPostHandler(url, args, formdata)
}


/**
 * 更新角色
 * @param {*} args 
 * @returns 
 */
export function updateRole (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/update';
	return axiosPostHandler(url, args, formdata)
}

/**
 * 撤销对某个用户的权限
 * @param {} args
 * @param {target_user_ids, id, department_id} formdata
 * @returns 
 */
export function revokeRoleFromUsers (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/revoke';
	return axiosPostHandler(url, args, formdata)
}

/**
 * 对某个用户授予某个角色
 * @param {*} args
 * @param {target_user_ids, id, department_id} formdata
 * @returns 
 */
export function addRoleUsers (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/grant';
	return axiosPostHandler(url, args, formdata)
}

// 批量用户授予某个角色
export function batchAddRoleUsers (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/batch_grant';
	return axiosPostHandler(url, args, formdata)
}

// 批量用户撤销某个角色
export function batchRevokeRoleFromUsers (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/batch_revoke';
	return axiosPostHandler(url, args, formdata)
}

/**
 * 对角色进行排序
 * @param {*} args
 * @param {id} formdata id: 新的排序结果list
 * @returns 
 */
export function sortRoles (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room_role/sort';
	return axiosPostHandler(url, args, formdata)
}

export function getRoleUserCount(args) {
	let url = BASE_API + '/chatroom/v2/room_role/role_user_count';
	return axiosGetHandler(url, args);
}

// 分页获得某个角色的用户信息
export function getRoleUsers(args) {
	let url = BASE_API + '/chatroom/v2/room_role/page_role_users';
	return axiosGetHandler(url, args);
}

export function getUserRoles(args) {
	let url = BASE_API + '/chatroom/v2/room_role/user_roles';
	return axiosGetHandler(url, args);
}

export function overwriteChannelPermission(args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel_role/overwrite';
	return axiosPostHandler(url, args, formdata);
}

export function deleteChannelRoleOverwrite(args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel_role/delete';
	return axiosPostHandler(url, args, formdata);
}

export function resetChannelOverwrites(args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel_role/sync';
	return axiosPostHandler(url, args, formdata);
}


// 获取用户权限列表
export function getUserPermissions(args) {
	let url = BASE_API + '/chatroom/v2/channel_user_perm/list';
	return axiosGetHandler(url, args);
}

// 更新频道角色和用户权限
export function updateChannelRoleAndUserPerm(args, formdata) {
	let url = BASE_API + '/chatroom/v2/role/role_user_perm';
	return axiosPostHandler(url, args, formdata);
}

// 获取频道用户权限
export function getChannelMemberPermission(args) {
	let url = BASE_API + '/chatroom/v2/channel_user_perm';
	return axiosGetHandler(url, args);
}

// 获取频道内所有已被设置过权限的成员权限列表
export function getChannelAllMembersPermission(args) {
	let url = BASE_API + '/chatroom/v2/channel_user_perm/list_with_parent';
	return axiosGetHandler(url, args);
}

// 更新频道内所有已被设置过权限的成员权限列表
export function updateChannelMembersPermission(args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel_user_perm/update';
	return axiosPostHandler(url, args, formdata);
}